<template>
  <div id="spin-library-wrapper">
    <base-card
      id="spin-library-song-list"
      heading="Library"
      :icons="libraryIcons"
      :searchEnabled="true"
      :scrollable="true"
      @icon-clicked="libraryIconClicked"
      @search="searchForTrack"
    >
      <div id="library-song-list-wrapper">
        <h5 v-if="error">{{ error }}</h5>
        <h5 v-if="matches.length > 0">Matches</h5>
        <library-track
          v-for="(track, index) in matches"
          :key="index"
          :track="track"
          :plusSign="true"
          @plus-sign-clicked="appendToPlaylist(track)"
        />
        <h5 v-if="matches.length > 0">Library</h5>
        <library-track
          v-for="(track, index) in tracks"
          :key="index"
          :track="track"
          :plusSign="matchingField"
          @plus-sign-clicked="appendToPlaylist(track)"
        />
      </div>
    </base-card>
    <base-card
      id="spin-library-side-bar"
      :heading="activeEvent ? activeEvent.title : 'Events'"
      :icons="sidebarIcons"
      :scrollable="true"
      @icon-clicked="sidebarIconClicked"
    >
      <!-- <div id="side-bar-container"> -->
      <div id="library-events-wrapper" v-if="!activeEvent">
        <library-event
          v-for="event in events"
          :key="event.userId"
          :event="event"
          @click="eventClicked(event)"
        />
      </div>
      <event-form
        v-if="activeEvent"
        :event="activeEvent"
        :chosenForm="chosenForm"
        @form-chosen="formChosen"
        @find-match="findMatch"
        @find-streaming-match="findStreamingMatch"
      />
      <!-- </div> -->
    </base-card>
    <input
      id="import-input"
      type="file"
      @change="uploadLibrary"
      style="display: none"
    />
  </div>
</template>
<script>
import { readFile, createPlaylistFile } from "../Helpers/library.js";
import BaseCard from "../Components/UI/BaseCard.vue";
import LibraryTrack from "../Components/UI/ListItems/Library/LibraryTrack.vue";
import LibraryEvent from "../Components/UI/ListItems/Library/LibraryEvent.vue";
import EventForm from "../Components/Library/Sidebar/EventForm.vue";
export default {
  data() {
    return {
      page: 0,
      activeEvent: undefined,
      chosenForm: undefined,
      matchingField: undefined,
      libraryUploading: false,
      searchProcessing: false,
      matchProcessing: false,
      matches: [],
      error: undefined,
      timer: null,
    };
  },
  computed: {
    events() {
      return this.$store.getters.events("future").sort((a, b) => {
        let startTime = (event) => {
          switch (event.api_version) {
            case "9-28-2022":
              return new Date(event.start_time).getTime();
            default:
              return new Date(event.data.startTime).getTime();
          }
        };
        let aStart = startTime(a);
        let bStart = startTime(b);
        return aStart < bStart ? -1 : aStart > bStart ? 1 : 0;
      });
    },
    tracks() {
      return this.$store.getters.libraryTracks(this.page);
    },
    playlists() {
      return this.$store.getters.libraryPlaylists;
    },
    libraryIcons() {
      let array = [];
      if (this.page === 0) {
        array.push(null);
      }
      if (this.page !== 0) {
        array.push("left-arrow-single");
      }
      if (this.endOfTracks) {
        array.push(null);
      }
      if (!this.endOfTracks) {
        array.push("right-arrow-single");
      }
      array.push("download");
      return array;
    },
    sidebarIcons() {
      let array = [];
      if (this.activeEvent) {
        array.push("left-arrow-single", "upload");
      }
      if (this.matchProcessing && this.activeEvent) {
        array.push("spinner");
      }
      if (!this.matchProcessing && this.activeEvent) {
        array.push("wand");
      }
      return array;
    },
    meta() {
      return this.$store.getters.libraryMeta;
    },
    backArrowActive() {
      if (this.activeEvent) {
        return true;
      } else {
        return false;
      }
    },
    endOfTracks() {
      return (this.page + 1) * 100 > this.$store.getters.libraryTracks().length;
    },
  },
  methods: {
    eventClicked(event) {
      this.activeEvent = event;
    },
    async formChosen(form) {
      this.chosenForm = form;
      console.log(form);
      if (form.streamingEnabled) {
        await this.$store
          .dispatch("getSpotifyPlaylist", form.streamingURI)
          .then((res) => {
            form.streamingTracks = res.tracks.items.map((x) => {
              return x.track;
            });
            console.log(form);
          });
      }
    },
    async searchForTrack(field) {
      if (field) {
        if (this.timer) {
          clearTimeout(this.timeout);
          this.timer = null;
        }
        this.searchProcessing = true;
        this.timer = setTimeout(async () => {
          this.matches = [];
          let array = await this.$store.dispatch("searchTracks", field);
          this.matches.push(...array.slice(0, 100));
          this.searchProcessing = false;
        }, 1500);
      } else {
        this.matches = [];
      }
    },
    async findExactMatches() {
      this.matchProcessing = true;
      for (let x = 0; x < this.chosenForm.fields.length; x++) {
        const field = this.chosenForm.fields[x];
        await this.findMatch(field);
      }

      if (this.chosenForm.streamingTracks) {
        for (let x = 0; x < this.chosenForm.streamingTracks.length; x++) {
          const track = this.chosenForm.streamingTracks[x];
          this.matchingField = this.chosenForm.streamingTracks[x];
          let searchString = track.name + " ";
          track.artists.forEach((x) => {
            searchString += x.name += " ";
          });
          console.log(searchString);
          let array = await this.$store.dispatch("searchTracks", searchString);
          console.log(array);
          if (array.length === 1) {
            this.appendToPlaylist(array[0]);
          } else {
            this.matches.push(...array);
          }
          if (x === this.chosenForm.streamingTracks.length - 1) {
            this.matchProcessing = false;
          }
        }
      }
    },
    async findMatch(field) {
      this.matchingField = field;
      this.matches = [];
      let searchItems = field.fields
        .map((x) => {
          return x.value;
        })
        .filter((x) => {
          return typeof x === "string";
        });
      let searchString = "";
      searchItems.forEach((x) => {
        searchString += x += " ";
      });
      let array = await this.$store.dispatch("searchTracks", searchString);
      if (array.length === 1) {
        this.appendToPlaylist(array[0]);
      } else {
        this.matches.push(...array);
      }
    },
    async findStreamingMatch(track) {
      return new Promise((resolve) => {
        this.matchingField = track;
        let searchString = track.name + " ";
        track.artists.forEach((x) => {
          searchString += x.name += " ";
        });
        console.log(searchString);
        this.$store.dispatch("searchTracks", searchString).then((res) => {
          console.log(res);
          if (res.length === 1) {
            this.appendToPlaylist(res[0]);
          } else {
            this.matches.push(...res);
          }
          resolve(res);
        });
      });
    },
    deleteMatch(field) {
      delete field.libraryMatch;
    },
    appendToPlaylist(match) {
      this.matchingField.libraryMatch = match;
      this.matchingField = undefined;
      this.matches = [];
    },
    navigateBackwards() {
      this.activeEvent = false;
      this.matchingField = undefined;
      this.matches = [];
    },
    importPlaylist() {
      document.getElementById("import-input").click();
    },
    async uploadLibrary(event) {
      this.libraryUploading = true;
      let library = await readFile(event);
      await this.$store.dispatch("uploadLibrary", library);
      this.libraryUploading = false;
    },
    libraryIconClicked(icon) {
      switch (icon) {
        case "left-arrow-single":
          this.page--;
          break;
        case "right-arrow-single":
          this.page++;
          break;
        case "download":
          this.importPlaylist();
          break;
        default:
          break;
      }
    },
    async sidebarIconClicked(icon) {
      switch (icon) {
        case "left-arrow-single":
          this.navigateBackwards();
          break;
        case "upload":
          createPlaylistFile(
            this.chosenForm,
            this.activeEvent,
            this.$store.getters.libraryMeta
          );
          break;
        case "wand":
          this.matchProcessing = true;
          await this.findExactMatches();
          break;
        default:
          break;
      }
    },
  },
  components: {
    BaseCard,
    LibraryTrack,
    LibraryEvent,
    EventForm,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #spin-library-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-evenly;
    /* min-width: 100%; */
  }

  #spin-library-song-list {
    width: 100%;
    height: calc(100% - 5px);
    /* overflow: scroll; */
  }

  #library-song-list-wrapper {
    height: 500px;
    width: 100%;
  }

  #spin-library-side-bar {
    width: 100%;
    max-height: 400px;
  }
  #side-bar-container {
    /* width: 400px; */
    height: 625px;
    padding: 0 15px;
    overflow: scroll;
  }

  h5 {
    text-transform: uppercase;
    width: 100%;
    padding: 10px 0;
    background-color: var(--contrastColor);
    color: var(--backgroundColor);
  }
  @media (min-width: 800px) {
    #spin-library-wrapper {
      max-height: 750px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      /* min-width: 100%; */
    }

    #spin-library-song-list {
      width: 100%;
      height: calc(100% - 5px);
      /* overflow: scroll; */
    }

    #library-song-list-wrapper {
      height: 625px;
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      /* overflow-y: scroll; */
    }

    #spin-library-side-bar {
      min-width: 400px;
      width: 400px;
      max-width: 400px;
      height: calc(100% - 5px);
      max-height: unset;
    }
    #side-bar-container {
      /* width: 400px; */
      height: 625px;
      padding: 0 15px;
      overflow: scroll;
    }

    h5 {
      text-transform: uppercase;
      width: 100%;
      padding: 10px 0;
      background-color: var(--contrastColor);
      color: var(--backgroundColor);
    }
  }
}
</style>
